const bazarDe = {
	common: {
		brandLabel: 'Marke',
		storeLabel: 'Geschäft',
		unitCount: '',
	},
	search: {
		placeholders: [
			'Produktname eingeben...',
			'Markenname eingeben...',
			'Shop-Name eingeben...',
			'Kategoriename eingeben...'
		]
	},
	sidebar: {
		categoriesTitle: 'Kategorien',
		storesTitle: 'Geschäfte',
	},
	store: {
		serviceAreaLabel: 'Liefergebiet',
		nationwide: 'Landesweit',
		productCount: 'Produkte',
		productsOfSuffix: 'Produkte',
		description: 'Unten finden Sie alle verfügbaren Produkte dieses Shops. Sie können nach Kategorien filtern.',
	},
	buttons: {
		details: 'Details',
		addToCart: 'In den Warenkorb',
		clearFilters: 'Filter zurücksetzen',
		close: 'Schließen',
	},
	empty: {
		title: 'Keine Produkte gefunden',
		subtitle: 'Bitte passen Sie Ihre Filter oder Suche an',
	},
};

export default bazarDe;


